import React from 'react';
import ReactDOM from 'react-dom';

import {
	Container,
	Button,
	Toolbar,
	Spacer,
	Title,
	Input,
	Icon,
	Loader
} from 'sg-styleguide';

import Theme from '../../../containers/theme';

import FilterButton from '../../filter-button';
import LoaderWrapper from '../../helpers/loader-wrapper';
import Sidebar from '../../sidebar';
import StepDescription from '../../step-description';
import {
	FlexWithPadding,
	SectionWithPadding,
	BoxWithPadding
} from '../../helpers';

class Themes extends React.Component{
	constructor(props) {
		super(props);

		this.initialState = {
			itemsPerPage: parseInt( this.props.step.items_per_page ),
			currentlyVisibleItems: parseInt( this.props.step.items_per_page ),
			currentTag: 'all',
			elements : this.props.elements
		}

		this.state = this.initialState;
	}

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll, true);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll, true);
	}

	onScroll = (e) => {
		// Bail if the load more button doesn't exist.
		if ( this.state.elements.length <= this.state.currentlyVisibleItems ) {
			return;
		}

		var loadMoreButtonOffset = document.getElementById('button-load-more-themes').getBoundingClientRect()
		if( document.body.offsetHeight > loadMoreButtonOffset.y ) {
			this.onLoadMore();
		}
	}

	onLoadMore() {
		this.setState({
			currentlyVisibleItems: this.state.currentlyVisibleItems + this.state.itemsPerPage
		});
	}

	reset = () => {
		this.setState( this.initialState );
	}

	changeCurrentTag = (tag) => {
		this.setState({
			currentTag: tag,
			elements: this.filterThemes(tag)
		});

		this.props.addThemeTag( tag );
	}

	renderThemes() {
		return this.state.elements.slice( 0, this.state.currentlyVisibleItems ).map(item => 
			<Theme
				id={item.id}
				key={item.id}
				themes={this.state.elements}
				props{...item}
			/>
		)
	}

	searchThemes = ( search ) => {
		var themes =  _.filter(this.props.elements, function(theme) {
			return theme.name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
		});

		this.setState({
			elements:  themes,
			currentTag: this.initialState.currentTag
		});
	}

	filterThemes(tag) {

		if ( tag === 'all' ) {
			return this.props.elements;			
		}

		return _.transform(this.props.elements, (result, value, key) => {
			value.tags.map((item) => {

				if ( item.tag === tag ) {
					result.push( value )
				}
			})

		}, []);
	}

	getThemeTags() {
		return _.transform(this.props.elements, (result, value, key) => {
			value.tags.map((item) => {

				if ( result.indexOf( item.tag ) === -1 ) {
					result.push( item.tag )
				}
			})

		}, []);
	}

	dispayLoadMoreButton () {
		// Do not show button if there are no more themes.
		if ( this.state.elements.length <= this.state.currentlyVisibleItems ) {
			return;
		}

		return (
			<Toolbar>
				<Spacer/>
				<div>
					<Button onClick={ this.onLoadMore.bind( this ) } id="button-load-more-themes">
						{window.wizardData.strings.load_more}
					</Button>
				</div>
				<Spacer/>
			</Toolbar>
		);
	}

	render() {
		return (
			<SectionWithPadding
				onLoad={this.props.loaded}
				padding={this.props.isPhone? ['none', 'none', 'none', 'none'] : ['small', 'none', 'none', 'none']}
			>
				{ ! this.props.isLoaded &&
					<Loader theme="dark">
						Loading...
					</Loader>
				}

				<StepDescription title={this.props.step.title} subtitle={this.props.step.subtitle} isPhone={this.props.isPhone} />


				<Container
					padding="none"
				>
					<FlexWithPadding
						padding={['x-small', 'small', 'none', 'small']}
					>
						<Sidebar
							tags={this.getThemeTags()}
							currentTag={this.state.currentTag}
							changeCurrentTag={this.changeCurrentTag}
							reset={this.reset}
							searchThemes={this.searchThemes}
							isPhone={this.props.isPhone}
						>
						</Sidebar>

						<BoxWithPadding
							sm="9"
							padding="none"
						>
							<FlexWithPadding
								padding={['none', 'none', 'none', 'none']}
								margin="none"
							>
								{ this.renderThemes() }
							</FlexWithPadding>
						</BoxWithPadding>
					</FlexWithPadding>

					{ this.dispayLoadMoreButton() }
				</Container>

			</SectionWithPadding>

		);
	}
}

export default LoaderWrapper(Themes);
